export { default } from "ember-stereo/helpers/sound-is-blocked";
